import { useCallback } from 'react';

import { usePico } from '../pico';

type TurnstileFailureReason = 'script_load_error' | 'script_timeout' | 'widget_error';

export const useTurnstileTracking = (surface: string) => {
  const pico = usePico();

  const trackTurnstileLoadFailed = useCallback(
    (reason: TurnstileFailureReason) => {
      pico.track('turnstile_load_failed', {
        turnstile_load_failed_reason: reason,
        turnstile_load_failed_surface: surface,
      });
    },
    [pico, surface],
  );

  return { trackTurnstileLoadFailed };
};
